import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_NGUONVON } from "../actions/NguonVon/actionTypes";
import {
  getListNguonVonSuccess,
  getListNguonVonFailure,
} from "../actions/NguonVon";
import NguonVonApi from "../service/nguonVonApi";

function* getListNguonVon(action) {
  try {
    const response = yield call(NguonVonApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListNguonVonSuccess(response.data));
    } else {
      yield put(getListNguonVonFailure());
    }
  } catch (error) {
    yield put(getListNguonVonFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_NGUONVON, getListNguonVon);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
